export const WHATSAPP_NUMBER = '5522992267315'
export const EMAIL = 'contato@lughar.com.br'

export function whatsappUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
